import React from "react";
//Material imports

import Grid from "@mui/material/Grid";
//Limitless imports
import { useExpertProfileContext } from "@limitless/expert";
import { usePageViewRecorder } from "@limitless/analytics";
import DashboardHeader from "../components/dashboard-widget/DashboardHeader";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import { ThemeProvider } from "@mui/material/styles";
import DashboardTile from "../components/dashboard-widget/DashboardTile";
import Tabs from "@mui/material/Tabs";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import DashboardRewards from "../components/dashboard-widget/DashboardRewards";
import DashboardRatings from "../components/dashboard-widget/DashboardRatings";
import DashboardTasks from "../components/dashboard-widget/DashboardTasks";
import Box from "@limitless/modern/layout/Box";
import { useTranslation } from "@limitless/common/hooks";
import ConversationTab from "@limitless/portal/components/conversation-tab/ConversationTab";

const ModernisedDashboardScreen = () => {
    const { profile, isDarkMode } = useExpertProfileContext();
    const { t } = useTranslation();
    const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    usePageViewRecorder("Dashboard");

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    padding: 4,
                    overflowY: "auto",
                    height: "calc(100vh - 120px)"
                }}
            >
                <Grid container direction="column" justifyContent="center" spacing={3}>
                    <Grid item sx={{ paddingTop: "18px!important" }}>
                        <DashboardHeader firstName={profile.firstName} />
                    </Grid>

                    <DashboardTile />

                    <Grid item sx={{ paddingTop: "0px!important" }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            TabIndicatorProps={{
                                style: {
                                    height: "4px"
                                }
                            }}
                        >
                            <ConversationTab id="rewards" label={t("Rewards")} />
                            <ConversationTab id="Ratings" label={t("Ratings")} />
                            <ConversationTab id="Tasks" label={t("Tasks")} />
                        </Tabs>
                    </Grid>
                    <Grid item sx={{ paddingTop: "0px!important" }}>
                        <Paper>
                            {value === 0 && <DashboardRewards />}
                            {value === 1 && <DashboardRatings />}
                            {value === 2 && <DashboardTasks />}
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    );
};

export default ModernisedDashboardScreen;
